import React, { useEffect } from 'react';
import './GeneralButton.css';
var canPress = true;
var description = "";

const GeneralButton = (props: any) => {

	const onChangeValueKeyboard = (e:any)=> {
		if((e.keyCode == 32 || e.keyCode == 13 || e.keyCode == 90) && props.onClick){ //32 - spacebar, 36 - enter
			props.onClick();
		}


		if(e.keyCode == 90 && e.altKey && props.onKeyPress && canPress){ //90 z
			props.onKeyPress(e);
			canPress = false;
		}
	};

	useEffect(() => {
		description = props.title;

		if(props.isPressureDressing) {
			if(!description) {
				description = 'Tap and hold';
			}
			description += ' to activate press and hold alt and z at the same time';
		}

		if(!description) {
			description = '';
		}
	}, [props.title])

	return (
		<div className="general-btn-background modal-disable-select" style={props.style} title={props.title ? props.title : ''}
			tabIndex={0}
			aria-label={description}
			role={props.noButton ? "" : "button"}
			onKeyUp={(e:any) => { canPress = true; if (props.onKeyUp) props.onKeyUp(e); }}
			onClick={props.onClick}
			// onKeyPress={(e:any) => { if (props.onKeyPress) props.onKeyPress(e); }}
			onKeyDown={onChangeValueKeyboard}>
			<div
				onClick={props.onClick}
				onMouseDown={props.onMouseDown}
				onMouseUp={props.onMouseUp}
				onMouseOut={props.onMouseUp}
				onTouchStart={props.onMouseDown}
				onTouchEnd={props.onMouseUp}
				onTouchCancel={props.onMouseUp}
				className={`general-btn ${props.color ? props.color : ''}`}
				style={{
					padding: '15px',
					paddingBottom: '5px'
					// height: '100%',
					// padding: '0',
					// minWidth: '150px'
				}}
				>
				<p style={{
					margin: '0',
					position: 'relative',
					top: '-5px',
					// transform: 'translate(0, -50%)',
					color: '#00303e',
					fontSize: '17px',
					// width: '100%'
				}}>{props.text}</p>
			</div>
		</div>
	);
};
export default GeneralButton;

export interface IGeneralButton {
  text: string,
  onClick: any
}